import Vue from 'vue';
import Vuex from 'vuex';
import VueLocalStorage from 'vue-localstorage';

Vue.use(Vuex);
Vue.use(VueLocalStorage);

export default new Vuex.Store({
    state: {
        mode: 'upload',
        token: null,
        cookieConsent: null,
        baseUrl: '',
        emailReset: '',
        pwa: null,

        start: false,
        terminalConnectorRunning: null,
        // it answered /status at all: running, though maybe not set up (503)
        terminalConnectorReachable: null,
        attemptedConnectorRegister: false,

        clickandbuyfollow: false,

        // set once by App's first /infos; Start.vue picks the upload view
        // only then, the flags that choose it are in /infos
        infosLoaded: false,

        infos: {
            name: '',
            email: '',

            siteNotice: '',
            dataPrivacy: '',

            logo: '',

            pictures: [],

            articles: [
                {
                    id: '',
                    paper: '',
                    size: '',
                    price: 0,
                },
            ],

            maxPicturesPerOrder: 0,
            fee: 0.0,
            feeDiscount: 0.0,

            maxFileSizeInMB: 0,
            allowedFileMimeTypes: [],
            allowedFileExtensions: [],

            transfer: {
                fixedScreensavers: [],
            },
        },
    },
    mutations: {},
    actions: {},
    modules: {},
});
